import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import PanelFrame from "../../ui/PanelFrame";
import siteConfig from "../../../config/siteConfig";
import "./NewsAll.scss";

const NewsAll = () => {
  const location = useLocation();
  const articles = siteConfig.news || [];

  useEffect(() => {
    const id = location.hash?.replace("#", "");
    if (!id) return;
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [location.hash, articles]);

  return (
    <div className="mu-news-page">
      <PanelFrame title="News & Announcements" className="mu-news-page__frame">
        <div className="mu-news-page__toolbar">
          <Link className="mu-news-page__back" to="/">
            ← Back to Home
          </Link>
        </div>

        <div className="mu-news-page__list">
          {articles.map((article) => (
            <article key={article.id || article.title} className="mu-news-card" id={article.id}>
              <header className="mu-news-card__head">
                <h2 className="mu-news-card__title">{article.title}</h2>
                <div className="mu-news-card__meta">
                  {article.tag ? (
                    <span className="mu-news-card__tag">{article.tag}</span>
                  ) : null}
                  <time className="mu-news-card__date">{article.date}</time>
                </div>
              </header>
              <div className="mu-news-card__body">
                {(article.body || []).map((p) => (
                  <p key={p}>{p}</p>
                ))}
              </div>
            </article>
          ))}

          {articles.length === 0 ? (
            <p className="mu-news-page__empty">No news published yet.</p>
          ) : null}
        </div>
      </PanelFrame>
    </div>
  );
};

export default NewsAll;
